// extracted by mini-css-extract-plugin
export default {"root":"ExpertStrip_root__HuOnX","avatar":"ExpertStrip_avatar__c8A8i","expertDetails":"ExpertStrip_expertDetails__U3DUP"};